import * as types from '../types/commercialInvoice';

const initialState = {
  commercialInvoices: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 1,
  },
};

const commercialInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_COMMERCIAL_INVOICES:
      return {
        ...state,
        commercialInvoices: action.payload,
      };
    default:
      return state;
  }
};

export default commercialInvoiceReducer;
